import {DoppeAllSupportedPremiumFeatures, DoppeAllSupportedPremiumFeaturesSpec} from "./doppe-premium.auto-generated";
import {objectPick} from "@wix/devzai-utils-common";

/**
 * This feature is used to distinguish between free and premium users.
 * We assume that this feature is enabled if and only if the user has an active premium plan.
 * It is recommended to use a feature that is not likely to be disabled in the future.
 */
export const DoppePremiumActiveDistinguishingFeature = DoppeAllSupportedPremiumFeatures.hopp_remove_banner;

/**
 * List of premium features that are actually implemented in the product.
 * This is used to filter the full list of supported premium features.
 */
export const DoppePremiumImplementedPremiumFeatures = [
    DoppeAllSupportedPremiumFeatures.hopp_remove_banner,
    DoppeAllSupportedPremiumFeatures.hopp_latest_items_action,
    DoppeAllSupportedPremiumFeatures.hopp_verified_badge,
    DoppeAllSupportedPremiumFeatures.hopp_advanced_page_presets,
    DoppeAllSupportedPremiumFeatures.hopp_list_premium_styles,
    DoppeAllSupportedPremiumFeatures.hopp_phone_number_collection,
    DoppeAllSupportedPremiumFeatures.hopp_add_items_to_list_action,
    DoppeAllSupportedPremiumFeatures.hopp_create_short_links,
    DoppeAllSupportedPremiumFeatures.hopp_indexed_links_in_search,
    DoppeAllSupportedPremiumFeatures.hopp_full_analytics,
    DoppeAllSupportedPremiumFeatures.hopp_allow_landing_pages,
    DoppeAllSupportedPremiumFeatures.hopp_allow_pre_rolls,
    DoppeAllSupportedPremiumFeatures.hopp_contact_management,
    DoppeAllSupportedPremiumFeatures.hopp_crm_integration_wix,
    DoppeAllSupportedPremiumFeatures.hopp_automations,
    DoppeAllSupportedPremiumFeatures.hopp_advanced_design_options,
    DoppeAllSupportedPremiumFeatures.connect_your_domain,
    DoppeAllSupportedPremiumFeatures.hopp_seo_settings,
    DoppeAllSupportedPremiumFeatures.hopp_social_share_settings_editing,
    DoppeAllSupportedPremiumFeatures.hopp_google_analytics,
    DoppeAllSupportedPremiumFeatures.creators_favicon_,
    DoppeAllSupportedPremiumFeatures.hopp_unlimited_pages,
    DoppeAllSupportedPremiumFeatures.hopp_allow_short_links,
    DoppeAllSupportedPremiumFeatures.media_storage_total,
    DoppeAllSupportedPremiumFeatures.creators_advanced_search_settings,
    DoppeAllSupportedPremiumFeatures.hopp_full_screen_view,
    DoppeAllSupportedPremiumFeatures.creators_monetization_actions,
    DoppeAllSupportedPremiumFeatures.creators_form_submission,
    DoppeAllSupportedPremiumFeatures.vip_support,
    DoppeAllSupportedPremiumFeatures.identity_collaborators,
    DoppeAllSupportedPremiumFeatures.creators_pre_rolls_count,
    DoppeAllSupportedPremiumFeatures.hopp_lock_action,
    DoppeAllSupportedPremiumFeatures.hopp_change_link_destination,
    DoppeAllSupportedPremiumFeatures.hopp_connect_payments_by_wix_on_hopp_met,
    DoppeAllSupportedPremiumFeatures.hopp_install_business_tpa_on_hopp_meta_s,
    DoppeAllSupportedPremiumFeatures.accept_payments,
    DoppeAllSupportedPremiumFeatures.hopp_has_pro_subscription,
    DoppeAllSupportedPremiumFeatures.remove_wix_ads,
    DoppeAllSupportedPremiumFeatures.remove_ascend_branding,
    DoppeAllSupportedPremiumFeatures.hopp_on_page_display,
    DoppeAllSupportedPremiumFeatures.hopp_enable_blog,
    DoppeAllSupportedPremiumFeatures.bookings_sms_reminders,
    DoppeAllSupportedPremiumFeatures.bookings_staff_limit
] satisfies DoppeAllSupportedPremiumFeatures[];

export const DoppePremiumFeaturesSpec = objectPick(DoppeAllSupportedPremiumFeaturesSpec, DoppePremiumImplementedPremiumFeatures);